import { render, staticRenderFns } from "./prospectlist.vue?vue&type=template&id=0cd03cf5"
import script from "./prospectlist.vue?vue&type=script&lang=js"
export * from "./prospectlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports